module.exports = __webpack_public_path__ + "img/marker_two_green1.8a7d38a6.png";